import { type CompanyConfig, TimeFormat } from '../interface';

export const DubaiExpressConfig: CompanyConfig = {
  id: '62a967ce-863f-48ad-b86b-f1c01eb33c86',
  lang: 'ru',
  langs: ['ru'],
  name: 'DubaiExpress',
  nameSecondary: 'DubaiExpress',
  currency: '₽',
  currencyCode: 'RUB',
  officialName: 'Dubai Express',
  uiVariant: 'marketplace',
  email: 'info@dubaiexpress.com',
  feedbackEmail: 'info@dubaiexpress.com',
  marketingEmail: 'marketing@dubaiexpress.com',
  phonePlaceholder: '+971',
  defaultPhoneCode: '+971',
  phoneNumber: '+971 XXX XXX XXX',
  ageRestricted: 0,
  timeZone: 'Asia/Dubai',
  minimalOrderFeeThreshold: 700,
  address: 'Dubai, UAE',
  canonical: 'https://dubaiexpress.ru',
  defaultVolumeDisplay: '1x',
  showCookieBanner: true,
  warehouse: {
    default: 'SG01',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 25.2653284,
      lng: 55.3631627,
    },
  },
  map: {
    center: { lat: 0, lng: 0 },
    zoom: 12,
  },
  paymentMethods: [],
  availablePaymentMethods: [],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    tg: 'https://t.me/dubaidutyfree_telegram',
    vk: 'https://vk.ru/dubaidutyfree',
    instagram: 'https://www.instagram.com/dubaiexpress/',
    facebook: 'https://www.facebook.com/dubaiexpress/',
    tiktok: 'https://www.tiktok.com/@dubaiexpress/',
    youtube: 'https://www.youtube.com/@dubaiexpress/',
    blog: '/blog',
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'REFERRAL_CODE',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://...',
  },
  appStoreUrl: {
    ios: 'https://apps.apple.com/...',
    android: 'https://play.google.com/...',
  },
  apis: {
    yaMetrika: {
      token: 106451003,
    },
  },
  countryCode: 'AE',
  license: {
    name: '',
    numberPrinary: '',
    numberSecondary: '',
  },
};
